import { useState, useEffect } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
    LayoutDashboard, Brain, Wallet, BrainCircuit, Database,
    DollarSign, CreditCard, Building2, Megaphone, Share2, Code2,
    Users, Monitor, CheckSquare, Bot, Newspaper, Gift, MessageSquare,
    KeyRound, Lock, Scale, ShieldCheck, Server, RefreshCw, Plug,
    BarChart, FileText, Bell, HelpCircle, Heart, Rocket,
    Crown, LogOut, X, ChevronDown, Globe,
    Search, TrendingUp, Calendar, Settings, Shield, Briefcase, Home,
    Palette, LayoutTemplate, Flame, Cpu, Swords, Zap, Sparkles,
    Clapperboard, Factory, Telescope, Landmark, Send, MessageCircle, Radio,
    Moon,
} from 'lucide-react'
import { ResponsiveAdBanner } from '../ads/ResponsiveAdBanner'
import { HouseAdSlot } from '../ads/HouseAdSlot' // [HOTFIX-FINAL-2 З6]

const ROLE_MENU = {
    owner: [
        { path: '/dashboard', id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
        { path: '/creative-hub', id: 'creativeHub', label: 'Ω OMEGA', icon: Rocket, badge: 'AI' },
        { path: '/analytics', id: 'analytics', label: 'Analytics', icon: BarChart },
        { path: '/ai-vs-human', id: 'aiVsHuman', label: 'AI vs Human', icon: Swords },
        { path: '/scheduler', id: 'scheduler', label: 'Планировщик', icon: Calendar },
        { path: '/settings', id: 'settings', label: 'Settings', icon: Settings },
    ],
    admin: [
        { path: '/dashboard', id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
        { path: '/creative-hub', id: 'creativeHub', label: 'Ω OMEGA', icon: Rocket, badge: 'AI' },
        { path: '/analytics', id: 'analytics', label: 'Analytics', icon: BarChart },
        { path: '/ai-vs-human', id: 'aiVsHuman', label: 'AI vs Human', icon: Swords },
        { path: '/scheduler', id: 'scheduler', label: 'Планировщик', icon: Calendar },
        { path: '/owner?tab=telegram', id: 'telegram', label: '📱 Telegram', icon: Send },
        { path: '/settings', id: 'settings', label: 'Settings', icon: Settings },
    ],
    staff: [
        { path: '/dashboard', id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
        { path: '/creative-hub', id: 'creativeHub', label: 'Ω OMEGA', icon: Rocket, badge: 'AI' },
        { path: '/analytics', id: 'analytics', label: 'Analytics', icon: BarChart },
        { path: '/ai-vs-human', id: 'aiVsHuman', label: 'AI vs Human', icon: Swords },
        { path: '/scheduler', id: 'scheduler', label: 'Планировщик', icon: Calendar },
        { path: '/settings', id: 'settings', label: 'Settings', icon: Settings },
    ],
    advertiser: [
        { path: '/dashboard', id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
        { path: '/creative-hub', id: 'creativeHub', label: 'Ω OMEGA', icon: Rocket, badge: 'AI' },
        { path: '/analytics', id: 'analytics', label: 'Analytics', icon: BarChart },
        { path: '/ai-vs-human', id: 'aiVsHuman', label: 'AI vs Human', icon: Swords },
        { path: '/scheduler', id: 'scheduler', label: 'Планировщик', icon: Calendar },
        { path: '/settings', id: 'settings', label: 'Settings', icon: Settings },
    ],
    creator: [
        { path: '/dashboard', id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
        { path: '/creative-hub', id: 'creativeHub', label: 'Ω OMEGA', icon: Rocket, badge: 'AI' },
        { path: '/analytics', id: 'analytics', label: 'Analytics', icon: BarChart },
        { path: '/ai-vs-human', id: 'aiVsHuman', label: 'AI vs Human', icon: Swords },
        { path: '/scheduler', id: 'scheduler', label: 'Планировщик', icon: Calendar },
        { path: '/settings', id: 'settings', label: 'Settings', icon: Settings },
    ],
    business: [
        { path: '/dashboard', id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard },
        { path: '/creative-hub', id: 'creativeHub', label: 'Ω OMEGA', icon: Rocket, badge: 'AI' },
        { path: '/analytics', id: 'analytics', label: 'Analytics', icon: BarChart },
        { path: '/ai-vs-human', id: 'aiVsHuman', label: 'AI vs Human', icon: Swords },
        { path: '/scheduler', id: 'scheduler', label: 'Планировщик', icon: Calendar },
        { path: '/settings', id: 'settings', label: 'Settings', icon: Settings },
    ],
}

const OWNER_GROUPS = [
    {
        id: 'overview',
        title: 'ОБЗОР',
        items: [
            { id: 'overview', label: 'Dashboard', icon: LayoutDashboard },
            { id: 'creativeHub', label: 'Ω OMEGA', icon: Rocket, badge: 'AI', path: '/creative-hub' },
            { id: 'analytics', label: '📊 Аналитика', icon: BarChart },
            { path: '/project-factory', label: '🏭 Project Factory', icon: Factory },
        ],
    },
    {
        id: 'omega',
        title: 'OMEGA',
        items: [
            { id: 'omega', label: 'Ω OMEGA Core', icon: Brain },
            { id: 'brainviz', label: '🧠 Нейросеть', icon: Brain },
            { id: 'selfOptimize', label: '🧠 Self-Optimize', icon: Brain },
            { id: 'memory', label: '💾 Память', icon: Database },
            { id: 'devstudio', label: '💻 DevStudio', icon: Code2 },
            { id: 'dream', label: '🌙 Dream Mode', icon: Moon },
            { id: 'boardroom', label: '🏛 Совет', icon: Users },
            { id: 'aiVsHuman', label: '🥊 AI vs Human', icon: Swords },
            { id: 'omegaFinance', label: '💰 OMEGA Finance', icon: Wallet },
            { id: 'omegaSkills', label: '🧠 OMEGA Skills', icon: BrainCircuit },
            { id: 'omegaMemory', label: '🗄️ OMEGA Memory', icon: Database },
            { id: 'agents', label: '🤖 AI Агенты', icon: Bot },
            { id: 'supreme', label: '🧠 OMEGA Supreme', icon: BrainCircuit },
        ],
    },
    {
        id: 'finance',
        title: 'ФИНАНСЫ',
        items: [
            { id: 'finance', label: 'Финансы', icon: DollarSign },
            { id: 'subscriptions', label: 'Подписки', icon: CreditCard },
            { id: 'monetization', label: '💸 Возвраты', icon: DollarSign },
            { id: 'requisites', label: '🏢 Реквизиты', icon: Building2 },
            { id: 'advertising', label: 'Реклама', icon: Megaphone },
            { id: 'referrals', label: 'Рефералы', icon: Share2 },
        ],
    },
    {
        id: 'team',
        title: 'КОМАНДА',
        items: [
            { id: 'team', label: 'Команда', icon: Users },
            { id: 'clients', label: '👥 Клиенты', icon: Users },
            { id: 'cabinets', label: 'Кабинеты', icon: Monitor },
            { id: 'tasks', label: '✅ Задачи', icon: CheckSquare },
            { id: 'boardroom', label: '🏢 Совет', icon: Building2, path: '/boardroom' },
            { id: 'prediction', label: '🔮 Разведка', icon: Telescope, path: '/prediction' },
            { id: 'investment', label: '💰 Инвестиции', icon: Landmark, path: '/investment' },
            { id: 'businessSpawner', label: '🚀 Рождение бизнеса', icon: Rocket },
        ],
    },
    {
        id: 'content',
        title: 'КОНТЕНТ',
        items: [
            { id: 'news', label: 'Новости', icon: Newspaper },
            { id: 'promo', label: 'Промо', icon: Gift },
            { id: 'templates', label: '📋 Шаблоны', icon: LayoutTemplate },
            { id: 'brandVoice', label: '🎨 Brand Voice', icon: Palette },
            { id: 'videoCreator', label: '🎬 AI Video', icon: Clapperboard, path: '/video-creator' },
            { id: 'neuroSales', label: '🧠 Neuro-Sales', icon: Brain, path: '/neuro-sales' },
            { id: 'scout', label: '🔥 Scout', icon: Flame },
            { id: 'telegram', label: '📱 Telegram', icon: Send },
            { id: 'channelManager', label: '📡 Каналы', icon: Radio },
            { id: 'adOrders', label: '🛒 Заказы рекламы', icon: Megaphone },
            { id: 'salesMetrics', label: '📈 Метрики продаж', icon: TrendingUp },
        ],
    },
    {
        id: 'client',
        title: 'CLIENT',
        items: [
            { id: 'analytics', label: '📊 Аналитика', icon: BarChart },
            { id: 'scheduler', label: '📅 Планировщик', icon: Calendar },
        ],
    },
    {
        id: 'settings',
        title: 'НАСТРОЙКИ',
        items: [
            { id: 'addonsManage', label: '🛠 Управление аддонами', icon: Sparkles }, // [ADDONS-MARKETPLACE-RESTORE] owner-only редактор аддонов
            { id: 'apiKeys', label: '🔑 API Keys', icon: KeyRound },
            { id: 'security', label: 'Безопасность', icon: Lock },
            { id: 'legal', label: 'Юр. лицо', icon: Scale },
            { id: 'legalSettings', label: '⚖️ Юр. настройки', icon: Scale },
            { id: 'audit', label: 'Аудит', icon: ShieldCheck },
            { id: 'servers', label: 'Серверы', icon: Server },
            { id: 'planner', label: '📅 Планировщик', icon: Calendar },
            { id: 'updates', label: 'Обновления', icon: RefreshCw },
            { id: 'integrations', label: 'Интеграции', icon: Plug },
            { id: 'aiAnalytics', label: 'AI Аналитика', icon: BarChart },
            { id: 'logs', label: 'Логи системы', icon: FileText },
            { id: 'notifications', label: 'Уведомления', icon: Bell },
            { id: 'support', label: '💬 Поддержка', icon: MessageCircle },
            { id: 'help', label: 'Помощь', icon: HelpCircle },
            { id: 'feedback', label: 'Feedback', icon: Heart },
            { id: 'devStudio', label: '🚀 DevStudio', icon: Rocket },
        ],
    },
]

const ACTIVE_COLOR = '#8B5CF6'

function useWindowWidth() {
    const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1440)
    useEffect(() => {
        const handle = () => setWidth(window.innerWidth)
        window.addEventListener('resize', handle)
        return () => window.removeEventListener('resize', handle)
    }, [])
    return width
}

function useLocalStorage(key, initial) {
    const [value, setValue] = useState(() => {
        try {
            const saved = localStorage.getItem(key)
            return saved !== null ? JSON.parse(saved) : initial
        } catch {
            return initial
        }
    })
    useEffect(() => {
        try {
            localStorage.setItem(key, JSON.stringify(value))
        } catch {}
    }, [key, value])
    return [value, setValue]
}

export function AppSidebar({
    userRole = 'creator',
    menuItems,
    user,
    onLogout,
    onClose,
    isMobile = false,
}) {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const [searchParams] = useSearchParams()
    const ownerTab = searchParams.get('tab')

    const [hovered, setHovered] = useState(false)
    const [openGroups, setOpenGroups] = useLocalStorage('sidebar_open_groups', {
        overview: true, omega: true, finance: true, team: true, content: true, settings: true,
    })

    const isOwner = userRole === 'owner'
    const windowWidth = useWindowWidth()
    // [UI-VERIFY] 1024–1439: сайдбар всегда collapsed (72px), раскрытие только hover-peek поверх контента.
    // Раньше `(expanded || hovered)` держал его раскрытым на 280px, а main в DashboardShell
    // на этой ширине имеет paddingLeft 72px → ~208px контента пряталось под сайдбар (все страницы, 1280px).
    // Тумблер expanded при этом всё равно ничего не менял (на ≥1440 isExpanded всегда true) — убран как мёртвый.
    const isExpanded = isMobile ? true : (windowWidth >= 1440 || (windowWidth >= 1024 && hovered))

    const roleMenu = menuItems || ROLE_MENU[userRole] || ROLE_MENU.creator

    const groups = isOwner ? OWNER_GROUPS : [{ id: 'main', title: t('sidebar.menu', 'МЕНЮ'), items: roleMenu.map(item => ({ ...item, path: item.path })) }]

    // [HOTFIX-2026-08-08] remove duplicate sidebar items (e.g. analytics in both overview and client groups)
    const dedupedGroups = groups.map(group => {
        const seen = new Set()
        const items = group.items.filter(item => {
            const key = item.id || item.path || item.label
            if (seen.has(key)) return false
            seen.add(key)
            return true
        })
        return { ...group, items }
    })

    const isItemActive = (item) => {
        if (item.path) {
            return location.pathname === item.path
        }
        if (isOwner) {
            const active = ownerTab || 'overview'
            return item.id === active
        }
        return location.pathname === item.path
    }

    const handleItemClick = (item) => {
        if (item.path) {
            navigate(item.path)
        } else if (isOwner && item.id) {
            navigate(`/owner?tab=${item.id}`, { replace: true })
        }
        onClose?.()
    }


    const toggleGroup = (groupId) => {
        setOpenGroups(prev => ({ ...prev, [groupId]: !prev[groupId] }))
    }

    const initials = (user?.name || userRole || 'U')
        .split(' ')
        .map(s => s[0])
        .join('')
        .slice(0, 2)
        .toUpperCase()

    const itemLabel = (item) => {
        if (item.id) return t(`sidebar.${item.id}`, item.label)
        return item.label
    }

    return (
        <div
            onMouseEnter={() => !isMobile && setHovered(true)}
            onMouseLeave={() => !isMobile && setHovered(false)}
            className={`flex flex-col h-full bg-[var(--bg)] border-r border-[var(--border)] transition-[width] duration-200 z-50 relative ${
                isExpanded ? 'w-[280px]' : 'w-[72px]'
            }`}
        >
            {/* Header */}
            <div className="p-4 border-b border-[var(--border)] flex items-center justify-between">
                <div className="flex items-center gap-3 overflow-hidden">
                    <div className="w-9 h-9 rounded-xl bg-[var(--primary)]/20 flex items-center justify-center flex-shrink-0">
                        <Crown className="w-5 h-5 text-[var(--primary)]" />
                    </div>
                    {isExpanded && (
                        <div className="min-w-0">
                            <h1 className="text-[var(--text)] font-bold text-sm leading-tight truncate">AI Viral</h1>
                            <p className="text-[var(--text-muted)] text-[10px]">Studio</p>
                        </div>
                    )}
                </div>
                <div className="flex items-center gap-1">
                    {onClose && isMobile && (
                        <button
                            onClick={onClose}
                            className="p-1.5 rounded-lg text-[var(--text-muted)] hover:text-[var(--text)] hover:bg-[var(--surface)] transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center"
                        >
                            <X className="w-4 h-4" />
                        </button>
                    )}
                </div>
            </div>

            {/* Mobile user avatar */}
            {isMobile && isExpanded && (
                <div className="px-4 py-3 border-b border-[var(--border)] flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[var(--primary)] to-fuchsia-500 flex items-center justify-center text-sm font-bold text-white flex-shrink-0 overflow-hidden">
                        {user?.avatar ? (
                            <img src={user.avatar} alt="avatar" className="w-full h-full object-cover" />
                        ) : (
                            initials || <Globe className="w-5 h-5" />
                        )}
                    </div>
                    <div className="min-w-0">
                        <p className="text-[var(--text)] text-sm font-medium truncate">{user?.name || userRole}</p>
                        <p className="text-[var(--text-muted)] text-[10px] truncate">{user?.email || `${userRole}@ai-viral.com`}</p>
                    </div>
                </div>
            )}

            {/* Navigation */}
            <nav className="flex-1 overflow-y-auto p-3 space-y-4">
                {dedupedGroups.map(group => (
                    <div key={group.id}>
                        {isExpanded ? (
                            <button
                                onClick={() => toggleGroup(group.id)}
                                className="w-full flex items-center justify-between px-3 py-1.5 text-[10px] font-semibold text-[var(--text-muted)] tracking-wider uppercase hover:text-[var(--text)] transition-colors min-h-[44px]"
                            >
                                {t(`sidebar.groups.${group.id}`, group.title)}
                                <ChevronDown
                                    className={`w-3 h-3 transition-transform ${openGroups[group.id] !== false ? 'rotate-180' : ''}`}
                                />
                            </button>
                        ) : (
                            <div className="px-3 py-1.5">
                                <div className="h-px bg-[var(--border-strong)]" />
                            </div>
                        )}
                        {(openGroups[group.id] !== false || !isExpanded) && (
                            <div className="space-y-1">
                                {group.items.map(item => {
                                    const Icon = item.icon
                                    const active = isItemActive(item)
                                    return (
                                        <button
                                            key={`${group.id}-${item.id || item.path}`}
                                            onClick={() => handleItemClick(item)}
                                            className={`
                                                group relative flex items-center gap-3 px-3 py-2.5 rounded-xl transition-colors duration-200 w-full text-left min-h-[44px]
                                                ${active
                                                    ? 'bg-[var(--primary-soft)] border-l-[3px] border-[var(--primary)] text-[var(--text)]'
                                                    : 'text-[var(--text-muted)] hover:text-[var(--text)] hover:bg-[var(--surface)]'
                                                }
                                                ${isExpanded ? '' : 'justify-center'}
                                            `}
                                            title={itemLabel(item)}
                                        >
                                            <Icon className="w-[18px] h-[18px] flex-shrink-0" />
                                            {isExpanded && <span className="font-medium text-sm truncate">{itemLabel(item)}</span>}
                                            {!isExpanded && (
                                                <span className="absolute left-full ml-2 px-2 py-1 rounded-lg glass z-tooltip text-xs text-[var(--text)] whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                                                    {itemLabel(item)}
                                                </span>
                                            )}
                                            {item.badge && isExpanded && (
                                                <span className="ml-auto px-1.5 py-0.5 rounded-full bg-[var(--primary)]/20 text-[var(--primary)] text-[10px] font-bold border border-[var(--primary)]/30">
                                                    {item.badge}
                                                </span>
                                            )}
                                            {active && <div className="absolute right-2 w-1.5 h-1.5 rounded-full bg-[var(--primary)]" />}
                                        </button>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                ))}
            </nav>

            {/* User */}
            <div className="p-3 border-t border-[var(--border)]">
                <div className={`flex items-center gap-3 px-3 py-2 ${isExpanded ? '' : 'justify-center'}`}>
                    <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[var(--primary)] to-[var(--primary)] flex items-center justify-center text-xs font-bold text-[var(--text-inverse)] flex-shrink-0 overflow-hidden">
                        {user?.avatar ? (
                            <img src={user.avatar} alt="avatar" className="w-full h-full object-cover" />
                        ) : (
                            initials || <Globe className="w-4 h-4" />
                        )}
                    </div>
                    {isExpanded && (
                        <div className="min-w-0">
                            <p className="text-[var(--text)] text-sm font-medium truncate">{user?.name || userRole}</p>
                            <p className="text-[var(--text-muted)] text-[10px] truncate">{user?.email || `${userRole}@ai-viral.com`}</p>
                        </div>
                    )}
                </div>

                {/* Ad slot in sidebar (desktop expanded).
                    [CHECKOUT-UNIFY] на /settings не показываем: фиксированная карточка наезжает на кнопки «Оплатить»
                    [HOTFIX-FINAL-2 З6] house-ads карточка в сайдбаре (спека Р3, в потоке — не fixed) */}
                {isExpanded && !isMobile && !location.pathname.startsWith('/settings') && (
                    <div className="px-3 pb-3">
                        <HouseAdSlot slot="sidebar" variant="sidebar" />
                    </div>
                )}

                <button
                    onClick={onLogout}
                    className={`w-full flex items-center gap-3 px-3 py-2 mt-1 rounded-xl text-sm text-[var(--danger)] hover:bg-[var(--danger)]/10 transition-all text-left min-h-[44px] ${
                        isExpanded ? '' : 'justify-center'
                    }`}
                    title={t('common.logout', 'Выйти')}
                >
                    <LogOut className="w-[18px] h-[18px] flex-shrink-0" />
                    {isExpanded && <span>{t('common.logout', 'Выйти')}</span>}
                </button>
                {isExpanded && (
                    <p className="mt-3 text-center text-[10px] text-[var(--text-muted)]">AI Viral Studio v9.9.21</p>
                )}
            </div>
        </div>
    )
}

export default AppSidebar
